import { render, staticRenderFns } from "./food.vue?vue&type=template&id=e0bf4b5e"
import script from "./food.vue?vue&type=script&lang=js"
export * from "./food.vue?vue&type=script&lang=js"
import style0 from "./food.vue?vue&type=style&index=0&id=e0bf4b5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports